import { FC, useEffect, useRef } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectLoading, selectMessages, selectStreamingActivities } from 'store/quizAgent/quizAgentSelectors';
// Markdown
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
// Components
import ActivityStatus from './ActivityStatus';

const MessagesList: FC = () => {
  const refListEnd = useRef<HTMLDivElement>(null);

  const messages = useAppSelector(selectMessages);
  const loading = useAppSelector(selectLoading);
  const streamingActivities = useAppSelector(selectStreamingActivities);

  useEffect(() => {
    refListEnd.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, streamingActivities]);

  return (
    <div className="overflow-y-auto flex-1 flex flex-col gap-2 p-2">
      {messages.map((msg, idx) => {
        const isUser = msg.role === 'user';

        return (
          <div
            key={idx}
            className={`
              p-3 rounded-lg mb-2
              ${isUser ? 'self-end' : 'self-start w-full'}
            `}
            style={{
              maxWidth: isUser ? '80%' : '100%',
              backgroundColor: isUser ? '#0C141A' : 'transparent'
            }}
          >
            {msg.content && (
              <div
                className={`
                  text-white
                  prose max-w-none
                  ${isUser ? 'prose-invert' : ''}
                  prose-p:my-1
                  prose-ul:my-1
                  prose-li:my-0
                  prose-headings:my-2
                `}
              >
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {msg.content}
                </ReactMarkdown>
              </div>
            )}
          </div>
        );
      })}
      {loading && (
        <div className="self-start w-full">
          <ActivityStatus activities={streamingActivities} />
        </div>
      )}
      <div ref={refListEnd} style={{ height: '1px' }} />
    </div>
  );
};

export default MessagesList;
